const CMS_SYNC_KEY = 'cms:last-update';
const CMS_SYNC_EVENT = 'cms:updated';

export function announceCmsUpdate(scope = 'site') {
  const payload = { scope, ts: Date.now() };
  try {
    localStorage.setItem(CMS_SYNC_KEY, JSON.stringify(payload));
  } catch (_) {
    // Ignore storage failures; same-tab listeners still work.
  }
  window.dispatchEvent(new CustomEvent(CMS_SYNC_EVENT, { detail: payload }));
}

export function subscribeCmsUpdates(callback) {
  if (typeof callback !== 'function') return () => {};

  const handleCustom = (event) => callback(event.detail || { scope: 'site', ts: Date.now() });
  const handleStorage = (event) => {
    if (event.key !== CMS_SYNC_KEY || !event.newValue) return;
    try {
      callback(JSON.parse(event.newValue));
    } catch (_) {
      callback({ scope: 'site', ts: Date.now() });
    }
  };

  window.addEventListener(CMS_SYNC_EVENT, handleCustom);
  window.addEventListener('storage', handleStorage);

  return () => {
    window.removeEventListener(CMS_SYNC_EVENT, handleCustom);
    window.removeEventListener('storage', handleStorage);
  };
}
